import { useHoverSound } from '../../hooks/useHoverSound'
import { RGB } from '../../utils/cssFilterGenerator'
import { CarRank } from '../stats/carRank/CarRank'
import './Card.css'

interface CardProps {
    name: string;
    brand: string;
    driveBias: 'FWD' | 'RWD' | 'AWD';
    carRank: number;
    isSelected?: boolean;
    color?: RGB;
    onSelect?: () => void;
}

// Улучшенный фильтр для перекраски красной машины в любой цвет
function getColorFilter(color?: { r: number; g: number; b: number }) {
    const dropShadow = 'drop-shadow(2px 4px 6px black)';
    if (!color) {
        // По умолчанию — красный
        return `${dropShadow} grayscale(0) brightness(1) hue-rotate(0deg)`;
    }
    const { r, g, b } = color;
    // Для черного
    if (r === 0 && g === 0 && b === 0) {
        return `${dropShadow} grayscale(1) brightness(0.15)`;
    }
    // Для белого
    if (r === 255 && g === 255 && b === 255) {
        return `${dropShadow} grayscale(1) brightness(2)`;
    }
    // Переводим RGB в HSL для hue-rotate и saturate
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h = 0, s = 0, l = (max + min) / 2 / 255;
    if (max === min) {
        h = 0;
    } else if (max === r) {
        h = 60 * ((g - b) / (max - min));
    } else if (max === g) {
        h = 60 * (2 + (b - r) / (max - min));
    } else {
        h = 60 * (4 + (r - g) / (max - min));
    }
    if (h < 0) h += 360;
    // s — насыщенность
    if (max === min) {
        s = 0;
    } else {
        s = (l > 0.5)
            ? (max - min) / (2 * 255 - max - min)
            : (max - min) / (max + min);
    }
    // Яркость по светлоте HSL
    const brightness = 0.7 + l * 0.8; // 0.7...1.5
    // Насыщенность (saturate) — от 0.7 до 2
    const saturate = 0.7 + s * 1.3;
    return `${dropShadow} grayscale(1) brightness(${brightness.toFixed(2)}) saturate(${saturate.toFixed(2)}) hue-rotate(${h.toFixed(0)}deg)`;
}

export const Card = (props: CardProps) => {
    const image = props.name.replace(/\s+/g, '').toLowerCase();
    const car = `/cars/small/${image}.png`;
    
    const hoverProps = useHoverSound('/sounds/hover4.mp3');

    let driveBiasIcon;
    if (props.driveBias === 'FWD') {
        driveBiasIcon = <img src={`/icons/driveBias/fwd.svg`} alt="FWD" style={{width: '21px', height: '21px'}} />;
    } else if (props.driveBias === 'RWD') {
        driveBiasIcon = <img src={`/icons/driveBias/rwd.svg`} alt="RWD" style={{width: '21px', height: '21px'}} />;
    } else if (props.driveBias === 'AWD') {
        driveBiasIcon = <img src={`/icons/driveBias/awd.svg`} alt="AWD" style={{width: '21px', height: '21px'}} />;
    }

    return (
        <div className={`card ${props.isSelected ? 'selected' : ''}`} onClick={props.onSelect}>
            <div className={`card-content ${props.isSelected ? 'selected' : ''}`}>
                <div className="card-content-header">
                    <h1 className="card-name">{props.name}</h1>
                    <h2 className="card-brand">{props.brand}</h2>
                </div>
                <div className="card-content-body">
                    <img 
                        className="card-image" 
                        src={`/cars/small/${image}.png`}
                        {...hoverProps}
                    />
                </div>
                <div className="card-content-footer">
                    {driveBiasIcon}
                    <CarRank rank={props.carRank} style={{fontSize: '14px', width: '25px'}} />
                </div>
            </div>
        </div>
    )
}
